import { useNavigate } from "react-router-dom";
import { tWithKeyAttr as t } from "../../i18nHelper";
import i18n from "../../i18n";
import { useAppSelector } from "../../services/hooks";
import { adminSelector } from "../../services/selectors/user.selectors";
import { useGetTokenForTherapistMutation } from "../../services/api/auth.api";
import { useEffect, useState } from "react";
import { string } from "yup";
interface Config {
  adminSiteUrl: string;
  therapistSiteUrl: string;
  clientSiteUrl: string;
  pocSiteUrl: string;
  adminSiteUrlTest: string;
  therapistSiteUrlTest: string;
  clientSiteUrlTest: string;
  pocSiteUrlTest: string;

}

export function EditText() {
  const admin = useAppSelector(adminSelector);
  const navigate = useNavigate();
  const [getTokenForTherapist] = useGetTokenForTherapistMutation();
  const [error, setError] = useState<string | undefined>(undefined);
  const [config, setConfig] = useState<Config>();
  const [configAd, setConfigAd] = useState<string>();
  const [configCl, setConfigCl] = useState<string>();
  const [configTh, setConfigTh] = useState<string>();
  const [configPoc, setConfigPoc] = useState<string>();

  useEffect(() => {
    if (window.location.hostname.includes("test") ||
      window.location.hostname.includes("local")) {
      setConfigAd(config?.adminSiteUrlTest);
      setConfigCl(config?.clientSiteUrlTest);
      setConfigPoc(config?.pocSiteUrlTest);
      setConfigTh(config?.therapistSiteUrlTest);
    } else {
      setConfigAd(config?.adminSiteUrl);
      setConfigCl(config?.clientSiteUrl);
      setConfigPoc(config?.pocSiteUrl);
      setConfigTh(config?.therapistSiteUrl);
    }
  }, [])


  useEffect(() => {
    const currentLanguage = i18n.language || 'he';
    fetch("/config.json", {
      headers: {
        'Accept-Language': currentLanguage,
        'X-App-Name': 'admin'
      }
    })
      .then((res) => res.json())
      .then((data) => setConfig(data));
  }, []);
  const goToClientSite = async () => {
    var targetUrl: string = "";
    if (config != null) {
      targetUrl = `${configCl}/${admin.guid}`;
      window.open(targetUrl, "_blank");
    }
    else {
      alert(t("ERROR_TRY_AGAIN"))
    }
  };
  const goToTherapistSite = async () => {
    var targetUrl: string = "";
    if (config != null) {
      targetUrl = `${configTh}/${admin.guid}`;
      window.open(targetUrl, "_blank");
    }
    else {
      alert(t("ERROR_TRY_AGAIN"))
    }
  };
  const goToAdminSite = async () => {
    var targetUrl: string = "";
    if (config != null) {
      targetUrl = `${configAd}/${admin.guid}`;
      window.open(targetUrl, "_blank");
    }
    else {
      alert(t("ERROR_TRY_AGAIN"))
    }
  };
  return <>
    <section className={`menuSection`}>
      <h1 className={`title title_blue`}>
        {t("WHICH_SITE_TO_EDIT")}</h1>
      <ul className={`options`}>
        <li className={`option hover`} onClick={() => { goToClientSite() }}>Client</li>
        <li className={`option hover`} onClick={() => { goToTherapistSite() }}>Therapist</li>
        <li className={`option hover`} >POC</li>
        <li className={`option hover`} onClick={() => { goToAdminSite() }}>Admin</li>
      </ul>
    </section>
  </>
}